"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.merge = void 0;
const isArray_1 = __importDefault(require("lodash/isArray"));
const mergeWith_1 = __importDefault(require("lodash/mergeWith"));
/*
 * Does deep merge. This is similar to `lodash` merge, but handles arrays differently:
 * `lodash` merges elements of arrays by their indices, this overwrites the existing
 * value with the array
 */
const merge = (...sources) => {
    const result = {};
    (0, mergeWith_1.default)(result, ...sources, (_, srcValue) => {
        if ((0, isArray_1.default)(srcValue)) {
            return [...srcValue];
        }
        else {
            return undefined; // no customization: does the default merging for this field
        }
    });
    return result;
};
exports.merge = merge;
//# sourceMappingURL=merge.js.map